import React, { useMemo, useContext } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../components/shared/Navbar";
import { AuthContext } from "../components/ContextApi/ContextApi";
import ReceiptPreview from "./ReceiptPreview";
import { RawBTPrinter } from "../utils/rawbtPrinter";

export default function ViewOldNewAccountsReportBluetooth() {
  const { state } = useLocation();
  const accounts = state?.accounts || [];

  const { firstName, lastName, userMobile, bank } =
    useContext(AuthContext);

  // ================= HELPERS =================
  const formatAmount = (val) => {
    const num = parseFloat(val);
    return isNaN(num) ? "0.00" : num.toFixed(2);
  };

  const safe = (v) => (v ? v : "");

  // ✅ FIXED DATE FORMAT (DD/MM/YYYY)
  const formatDateDDMMYYYY = (date = new Date()) => {
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  };

  const today = formatDateDDMMYYYY();

  // ================= PREVIEW TEXT =================
  const previewText = useMemo(() => {
    if (!accounts.length) return "No account records found.";

    let lines = [];
    let total = 0;

    lines.push("** VIEW ALL ACCOUNT REPORT **");
    lines.push(bank || "");
    lines.push(`DATE : ${today}`);
    lines.push(`AGENT : ${firstName} ${lastName}`);
    lines.push("");
    lines.push("-".repeat(32));

    accounts.forEach((acc) => {
      const balance =
        acc.PresentBalance > 0
          ? acc.PresentBalance
          : acc.PreviousBalance || 0;

      total += parseFloat(balance) || 0;

      lines.push(
        `A/C : ${safe(acc.AccountNo)}     BALANCE : ${formatAmount(balance)}`
      );
      lines.push(`NAME  : ${safe(acc.Name)}`);
      lines.push("-".repeat(32));
    });

    lines.push(`TOTAL : ${formatAmount(total)}`);
    lines.push("");
    lines.push("END OF REPORT");

    return lines.join("\n");
  }, [accounts, bank, firstName, lastName, today]);

  // ================= BLUETOOTH PRINT =================
  const handlePrintReport = () => {
    if (!accounts.length) {
      alert("No account data to print!");
      return;
    }

    let commands = "";
    let total = 0;

    commands += "\x1B@";      // INIT
    commands += "\x1Ba\x01";  // CENTER

    commands += "** VIEW ALL ACCOUNT REPORT **\n";
    commands += `${bank}\n`;
    commands += `DATE : ${today}\n`;
    commands += `AGENT : ${firstName} ${lastName}\n\n`;

    commands += "\x1Ba\x00";  // LEFT
    commands += "-".repeat(32) + "\n";

    accounts.forEach((acc) => {
      const balance =
        acc.PresentBalance > 0
          ? acc.PresentBalance
          : acc.PreviousBalance || 0;

      total += parseFloat(balance) || 0;

      commands +=
        `A/C : ${safe(acc.AccountNo)}     BALANCE : ${formatAmount(balance)}\n`;
      commands += `NAME  : ${safe(acc.Name)}\n`;
      commands += "-".repeat(32) + "\n";
    });

    commands += `TOTAL : ${formatAmount(total)}\n\n`;

    commands += "\x1Ba\x01";  // CENTER
    commands += "END OF REPORT\n\n\n";

    RawBTPrinter.printEscPos(commands);
  };

  // ================= UI =================
  return (
    <div>
      <Navbar />

      <div style={{ padding: "10px 20px", marginTop: "70px" }}>
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <button
            onClick={handlePrintReport}
            style={{
              padding: "10px 20px",
              backgroundColor: "#007bff",
              color: "white",
              border: "none",
              borderRadius: "6px",
              fontWeight: "bold",
            }}
          >
            🖨 Print Account Report
          </button>
        </div>

        {/* PREVIEW */}
        <div style={{ marginTop: "20px", textAlign: "left" }}>
          <ReceiptPreview text={previewText} />
        </div>
      </div>
    </div>
  );
}
